// extracted by mini-css-extract-plugin
export default {"loginContainer":"AddResourcePage_loginContainer__VelTQ","loginContainers":"AddResourcePage_loginContainers__LX6kp"};